// External modules
import React from 'react';
import { isEmpty, cloneDeep } from 'lodash';

import FileCopyIcon from '@material-ui/icons/FileCopyRounded';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';

import ACButton from '../../atoms/ACButton';
import ACStatus from '../../atoms/ACStatus';
import ACUIElement from '../../atoms/ACUIElement';
import ACSaveBar from '../../atoms/ACSaveBar';
import ACMedia from '../../atoms/ACMedia';
import Select from 'react-select';

import { getMediaForUIName, getUIElementType, getUIElement } from '../../common/global';

import styles from './SparkDetails.module.scss';
import TagsPanel from './TagsPanel';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
export default class SparkDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      spark: props.spark || {},
      updateData: {}, // This holds all the changes to be saved
      equipment: {
        media: { section: 'equipment', url: '', type: 'image', text: '' },
      },
      openAlertDialog: false, 
      reloadKey: Math.random(),
    };
  }

  componentDidUpdate(prevProps) {
    const { spark = {}, media = {} } = this.props;
    if (!isEmpty(spark) && spark !== prevProps.spark) {
      if (spark.id === '-1') {
        this.setState({ updateData: { status: 'active' } });
      } else {
        this.setState({ updateData: {} });
      }
      this.setState({ spark });
    }

    if (!isEmpty(media) && media !== prevProps.media) {
      this.updateMedia(media);
    }
  }

  updateMedia(media) {
    const { spark = {}, equipment = {} } = cloneDeep(this.state);
    const { name, url } = media;
    let uiElement = {};
    let uiEleMedia = {};
    switch (name) {
      case 'introduction':
        uiElement = getUIElement(spark.uiElements, getUIElementType().introduction);
        break;
      case 'introductionCallOut':
        uiElement = getUIElement(
          spark.uiElements,
          getUIElementType().introduction,
          getUIElementType().callOut
        );
        break;
      case 'equipmentMedia':
        const { media = {} } = equipment;
        media.url = url;
        this.setState({ equipment });
        break;
      case 'ending':
        uiElement = getUIElement(spark.uiElements, getUIElementType().ending);
        break;
      case 'endingCallOut':
        uiElement = getUIElement(
          spark.uiElements,
          getUIElementType().ending,
          getUIElementType().callOut
        );
        break;
      case 'callOut':
        uiElement = getUIElement(spark.uiElements, getUIElementType().callOut);
        break;
      case 'equipment':
        uiElement = getUIElement(spark.uiElements, getUIElementType().callOut);
        break;
      default:
        break;
    }
    if (isEmpty(uiElement)) return;

    uiEleMedia = uiElement.media || {};
    uiEleMedia.url = url;
    uiElement.media = uiEleMedia;
    this.updateSparkData(cloneDeep(uiElement));
  }

  updateSparkData(uiElement) {
    const { spark = {}, updateData } = cloneDeep(this.state);
    let { uiElements = [] } = spark;
    const { type = '', subType = '' } = uiElement;
    uiElements = uiElements ? uiElements : [];
    const index = uiElements.findIndex((ele) => {
      if (!isEmpty(subType)) {
        return ele.type === type && ele.subType === subType;
      } else return ele.type === type && isEmpty(ele.subType);
    });
    if (index >= 0) uiElements[index] = uiElement;
    else uiElements.push(uiElement);

    spark.uiElements = uiElements;
    updateData.uiElements = uiElements;
    this.setState({ spark, updateData });
  }

  onChangeACUIElement = (uiElement) => {
    this.updateSparkData(uiElement);
  };

  onUploadACUIElementMedia = (name, s3FolderName, mediaType, file) => {
    const mediaFor = { ui: getMediaForUIName().spark, name: name, s3FolderName: s3FolderName };

    this.props.uploadMediaFunc(mediaFor, mediaType, file);
  };

  onUploadEquipmentMedia = (e) => {
    if (!e.target) return null;
    const { files = [] } = e.target;

    const { equipment = {} } = cloneDeep(this.state);
    const { media = {} } = equipment;
    const mediaFor = {
      ui: getMediaForUIName().spark,
      name: 'equipmentMedia',
      s3FolderName: 'generic',
    };

    this.props.uploadMediaFunc(mediaFor, media.type, files[0] || {});
  };

  onChangeText = (event) => {
    const { name = '', value = '' } = event.target || {};
    if (isEmpty(name)) return;

    let { spark, updateData } = cloneDeep(this.state);
    spark[name] = value;
    updateData[name] = value;
    this.setState({ spark, updateData });
  };

  onChangeCategory = (event) => {
    const category = 'category';
    const { value = '' } = event || {};
    if (isEmpty(category)) return;

    let { spark, updateData } = cloneDeep(this.state);
    spark[category] = value;
    updateData[category] = value;
    this.setState({ spark, updateData });
  };

  onChangeEquipmentMediaText = (event) => {
    const { value = '' } = event.target || {};

    const { equipment = {} } = cloneDeep(this.state);
    const { media = {} } = equipment;
    media['text'] = value;
    this.setState({ equipment });
  };

  onAddEquipmentMedia = () => {
    const { spark, equipment = {} } = cloneDeep(this.state);
    const { media = {} } = equipment;
    if (isEmpty(media.url) && isEmpty(media.text)) return;
    const uiElement = getUIElement(spark.uiElements, getUIElementType().equipment);
    const { medias = [] } = uiElement;
    medias.push(cloneDeep(media));
    media.text = '';
    media.url = '';
    equipment.media = media;

    uiElement.medias = cloneDeep(medias);

    this.setState({ equipment });
    this.updateSparkData(uiElement);
  };

  onDeleteEquipmentMedia = (index) => {
    const { spark } = cloneDeep(this.state);
    if (index < 0) return;
    const uiElement = getUIElement(spark.uiElements, getUIElementType().equipment);
    const { medias = [] } = uiElement;
    medias.splice(index, 1);
    uiElement.medias = cloneDeep(medias);

    this.updateSparkData(uiElement);
  };

  onChangeNotes = (event) => {
    const { name = '', value = '' } = event.target || {};
    if (isEmpty(name)) return;

    let { spark, updateData } = cloneDeep(this.state) || {};

    const { note = {} } = spark;
    note[name] = value;
    spark.note = note;
    updateData.note = note;
    this.setState({ spark, updateData });
  };

  onCopySpark = () => {
    const { spark } = cloneDeep(this.state);
    const { name = '' } = spark;
    delete spark.id;
    spark.name = `Copy of ${name}`;
    this.props.onCopySparkFunc(spark);
  };

  onSaveSpark = () => {
    const { spark, updateData } = cloneDeep(this.state);
    if (!spark.name?.trim() || !spark.category) {
      this.setState({
        openAlertDialog: true,
      });
      return;
    }
    //const ignoreACUIElementMedias = [getUIElementType().equipment];
    if (!isEmpty(spark) && spark.id !== '-1') updateData.id = spark.id;

    const { uiElements = [] } = updateData;
    if (!isEmpty(uiElements)) {
      uiElements.forEach((uiElement) => {
        const { type } = uiElement;
        // const index = ignoreACUIElementMedias.findIndex((iUIEleType) => {
        //   return type === iUIEleType.type;
        // });
        if (type !== getUIElementType().equipment) this.setACUIElementMedias(uiElement);
        else {
          delete uiElement.media;
        }
      });
    }

    this.props.onSaveSparkFunc(updateData);
    this.setState({
      reloadKey: Math.random(),
    });
  };

  setACUIElementMedias(uiElement) {
    const { media = {}, medias = [] } = uiElement;

    if (isEmpty(medias)) {
      if (!isEmpty(media)) medias.push(cloneDeep(media));
    } else {
      const lastMedia = medias[medias.length - 1] || { url: '' };
      if (!isEmpty(media) && media.url !== lastMedia.url) {
        medias.push(cloneDeep(media));
      }
    }
    delete uiElement.media;
    if (!isEmpty(medias)) uiElement.medias = medias;
  }

  onTagsUpdated = (tags) => {
    let { spark, updateData } = cloneDeep(this.state);
    spark['tags'] = tags;
    updateData['tags'] = tags;
    this.setState({ spark, updateData });
  };

  renderInternal(note) {
    let { spark } = cloneDeep(this.state);
    return (
      <>
      <div className={styles.section}>
        Internal Summary
        <TextField
          name="private"
          value={note.private || ''}
          className={styles.note}
          onChange={this.onChangeNotes}
          placeholder="Eg, if John isn't there ask for Claire."
          multiline
          rows="3"
        />
      </div>
      {spark.category === 'wonderpass' && 
      <div>
        <TagsPanel key={this.state.reloadKey} tags={this.state.spark?.tags} updateTags={this.onTagsUpdated} mode='edit' />
      </div>
      }
      </>
    );
  }

  renderCallOut() {
    const mediaFor = 'generic';
    const { spark = {} } = cloneDeep(this.state);
    const { uiElements } = spark;
    const callOut = getUIElement(uiElements, getUIElementType().callOut);

    return (
      <div className={styles.section}>
        <div className={styles.sectionHeading}>Call Out</div>
        <ACUIElement
          name="callOut"
          mediaFor={mediaFor}
          uiElement={callOut}
          onChangeACUIElementFunc={this.onChangeACUIElement}
          onUploadACUIElementMediaFunc={this.onUploadACUIElementMedia}
        />
      </div>
    );
  }

  renderEquipment() {
    const mediaFor = 'generic';
    const { spark = {} } = cloneDeep(this.state);
    const { uiElements } = spark;
    const equipment = getUIElement(uiElements, getUIElementType().equipment);

    return (
      <div className={styles.section}>
        <div className={styles.sectionHeading}>Equipment</div>
        <ACUIElement
          name="equipment"
          mediaFor={mediaFor}
          uiElement={equipment}
          showMedia={false}
          onChangeACUIElementFunc={this.onChangeACUIElement}
        />
        {this.renderEquipmentMedia()}
      </div>
    );
  }

  renderEquipmentMedia() {
    const { equipment = {} } = cloneDeep(this.state);
    const { media = {} } = equipment;
    return (
      <div className={styles.equipmentMedia}>
        <TextField
          name="mediaText"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={styles.adornment}>
                Media Text
              </InputAdornment>
            ),
          }}
          className={styles.textField}
          value={media.text || ''}
          onChange={this.onChangeEquipmentMediaText}
          placeholder="Text"
        />
        <ACMedia
          name="equipmentMedia"
          media={media}
          accept="image/*"
          onUploadMediaFunc={this.onUploadEquipmentMedia}
        />
        <div
          style={{
            background: 'rgb(82, 168, 239)',
            margin: '10px 5px',
            textAlign: 'center',
          }}
        >
          <Button
            component="span"
            style={{
              color: 'white',
            }}
            onClick={this.onAddEquipmentMedia}
          >
            Add Equipment Media
          </Button>
        </div>
        {this.renderEquipmentMedias()}
      </div>
    );
  }

  renderEquipmentMedias() {
    const { spark = {} } = cloneDeep(this.state);
    const { uiElements = [] } = spark;

    const equipment = getUIElement(uiElements, getUIElementType().equipment);

    const { medias = [] } = equipment;

    return medias.map((media, index) => {
      return (
        <div className={styles.selectedEquipmentMedia} key={index}>
          <div style={{ margin: 'auto 10px' }}>{media.text}</div>
          <div className={styles.mediaImageContainer}>
            <img alt="photo_media" src={media.url || ''} className={styles.mediaImage} />
          </div>
          <div style={{ margin: 'auto 0px' }} onClick={() => this.onDeleteEquipmentMedia(index)}>
            <DeleteIcon
              style={{
                color: '#FF765F',
                cursor: 'pointer',
              }}
            />
          </div>
        </div>
      );
    });
  }

  renderIntroduction() {
    // TODO: Change mediaFor to more appropriate folder name

    const mediaFor = 'generic';
    const { spark = {} } = cloneDeep(this.state);
    const { uiElements } = spark;
    const introduction = getUIElement(uiElements, getUIElementType().introduction);

    const introductionCallOut = getUIElement(
      uiElements,
      getUIElementType().introduction,
      getUIElementType().callOut
    );

    return (
      <div className={styles.section}>
        <div className={styles.sectionHeading}>Introduction</div>
        <ACUIElement
          name="introduction"
          mediaFor={mediaFor}
          uiElement={introduction}
          onChangeACUIElementFunc={this.onChangeACUIElement}
          onUploadACUIElementMediaFunc={this.onUploadACUIElementMedia}
          showTitle={true}
          titleHeading="Spark Title"
          showMediaIntro={true}
          showMedia={false}
          spark={spark}
        />
        <div className={styles.sectionSubHeading}>Call Out</div>
        <ACUIElement
          name="introductionCallOut"
          mediaFor={mediaFor}
          uiElement={introductionCallOut}
          showBody={false}
          onChangeACUIElementFunc={this.onChangeACUIElement}
          onUploadACUIElementMediaFunc={this.onUploadACUIElementMedia}
        />
      </div>
    );
  }

  renderEnding() {
    // TODO: Change mediaFor to more appropriate folder name

    const mediaFor = 'generic';
    const { spark = {} } = cloneDeep(this.state);
    const { uiElements } = spark;
    const ending = getUIElement(uiElements, getUIElementType().ending);

    const endingCallOut = getUIElement(
      uiElements,
      getUIElementType().ending,
      getUIElementType().callOut
    );

    return (
      <div className={styles.section}>
        <div className={styles.sectionHeading}>Ending</div>
        <ACUIElement
          name="ending"
          mediaFor={mediaFor}
          uiElement={ending}
          showMedia={true}
          onChangeACUIElementFunc={this.onChangeACUIElement}
          onUploadACUIElementMediaFunc={this.onUploadACUIElementMedia}
        />
        <div className={styles.sectionSubHeading}>Call Out</div>
        <ACUIElement
          name="endingCallOut"
          mediaFor={mediaFor}
          uiElement={endingCallOut}
          showBody={false}
          onChangeACUIElementFunc={this.onChangeACUIElement}
          onUploadACUIElementMediaFunc={this.onUploadACUIElementMedia}
        />
      </div>
    );
  }

  renderAlertDialog(alertText) {
    
    const onClickAlertDialogClose = () => {
      this.setState({
        openAlertDialog: false,
      });
    }

    return (
      <div>
        <Dialog open={this.state.openAlertDialog} aria-labelledby="draggable-dialog-title">
          <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
            Required fields
          </DialogTitle>
          <DialogContent>
            <DialogContentText>{alertText}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={onClickAlertDialogClose} color="primary">
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );    
  }  

  render() {
    const { spark = {}, updateData = {} } = cloneDeep(this.state);
    if (isEmpty(spark)) return <div />;
    const isEnabled = !isEmpty(updateData);
    const { name = '', note = {}, status = '', category = '' } = spark;
    const categories = [
      { label: 'Experience Step - Generic', value: 'generic' },
      { label: 'Experience Step - Exclusive', value: 'exclusive' },
      { label: 'Tailor-Made Customisation', value: 'customization' },
      { label: 'Experience Personalisation - WonderPass', value: 'wonderpass' },
      { label: 'Micro Experience', value: 'microexperience' },
      { label: 'Other', value: 'other' },
    ];
    return (
      <div className={styles.root}>
        <div className={styles.top}>
          <div className={styles.header}>
            Details
            <ACStatus
              name={status}
              type="spark"
              status={status || 'select'}
              isEditable={true}
              onChangeFunc={this.onChangeText}
            />
          </div>
          <div>
            <div className={styles.name}>
              <TextField
                name="name"
                value={name}
                className={styles.nameText}
                onChange={this.onChangeText}
                placeholder="Internal Spark Name"
              />
            </div>
          </div>
        </div>
        <div>           
          <div className={styles.selectAutoComplete}>
            <div className={styles.selectAutoCompleteMain}>
              <span>Category</span>
              <Select
                className={styles.select}
                inputId="react-select-category"
                TextFieldProps={{
                  InputLabelProps: {
                    htmlFor: 'react-select-category',
                    shrink: true,
                  },
                }}
                options={categories}
                value={
                  categories.filter(c => c.value === category)
                }
                onChange={this.onChangeCategory}
              />
            </div>
          </div>
        </div>
        <div className={styles.bottom}>
          {this.renderInternal(note)}
          {/* {this.renderCallOut()} */}
          {this.renderIntroduction()}
          {this.renderEquipment()}
          {this.renderEnding()}
          <div className={styles.sectionHeading} style={{width: '100%'}}>
            <ACButton text={'Clone'} icon={<FileCopyIcon />} onClickFunc={this.onCopySpark} />
          </div>
          {this.renderAlertDialog('Before this spark can be saved the following fields are required: Spark Name and Category. Please update before trying to save again.')}
        </div>        
          <ACSaveBar isEnabled={isEnabled} onSaveFunc={this.onSaveSpark} />       
      </div>
    );
  }
}
